module.exports = __webpack_public_path__ + "img/vignettes-asso_0011_josephine.f7381dd7.jpg";